

document.addEventListener('DOMContentLoaded', function() {
  console.log('js appended');

  // Custom language select click
  document.querySelectorAll('.custom_lag_select').forEach(function(element) {
    element.addEventListener('click', function() {
      document.querySelector('.cust-currency #CurrencyList').classList.toggle('disclosure-list--visible');
    });
  });

  // // Currency item click
  // document.querySelectorAll('#currency-target .disclosure-list__item').forEach(function(element) {
  //   element.addEventListener('click', function() {
  //     var val_cur = this.querySelector('a').dataset.value;
  //     console.log(val_cur, "currency_val");
  //     document.querySelector('.cust-currency [name=currency_code]').value = val_cur;
  //     document.querySelector('.cust-currency form').submit();
  //   });
  // });
  

  // // Custom language select 1 click
  // document.querySelectorAll('.custom_lag_select1').forEach(function(element) {
  //   element.addEventListener('click', function() {
  //     console.log(document.querySelector('.cust-currency #LangList'),'kkkk')
      
  //     document.querySelector('.cust-currency #LangList').classList.add('disclosure-list--visible');
  //   });
  // });

 
  
  // Language item click
  // document.querySelectorAll('#LangList .disclosure-list__item').forEach(function(element) {
  //   element.addEventListener('click', function() {
  //     var val_cur1 = this.querySelector('a').dataset.value;
  //     console.log(val_cur1);
  //     document.querySelector('.cust-currency [name=locale_code]').value = val_cur1;
  //     document.querySelector('.cust-currency .currency-form').submit();
  //   });
  // });

  // Slide nav return button click
  document.querySelectorAll('.slide-nav__return-btn').forEach(function(element) {
    element.addEventListener('click', function() {
      console.log('clicked hdh');
      var parent = this.closest('#LangList').querySelector('#currency-target');
      if (parent) {
        parent.classList.remove('is-active');
      }
    });
  });

  // Toggle submenu click
  document.querySelectorAll('.js-toggle-submenu').forEach(function(element) {
    element.addEventListener('click', function() {
      var siblings = this.closest('li').parentNode.children;
      Array.from(siblings).forEach(function(sibling) {
        if (sibling !== this.closest('li')) {
          sibling.querySelectorAll('.slide-nav__dropdown').forEach(function(dropdown) {
            dropdown.classList.remove('is-active');
          });
        }
      }, this);
    });
  });

  // Disclosure item click
//   document.querySelectorAll('.disclosure-list__item').forEach(function(element) {
//     element.addEventListener('click', function(e) {
//       e.preventDefault();
//       var val_cur = this.querySelector('a').dataset.value;
//       var form = this.closest('form');
//       if (form) {
//         form.querySelector('[data-disclosure-input]').value = val_cur;
//         form.submit();
//       }
//     });
//   });
// });
  


// mobile lang selector

var languageSelects = document.querySelectorAll(".custom-langlist");
  console.log(languageSelects);

var mediaQuery = window.matchMedia("(min-width: 768px)");

languageSelects.forEach(function(langsel) {
  langsel.querySelectorAll(".custom_lang_link").forEach(function(anchor) {
    anchor.addEventListener("click", function(e) {
      e.preventDefault()
      console.log(anchor)
      var lang = anchor.getAttribute("lang")
      if(lang == 'en'){
        var route = window.location.href
        // if url contains french in it 
          if (route.includes('fr')) {
          var newRoute = route.replace('/fr', '');
          window.location.href = newRoute;
        }else{
            return 
        }
      }
      else if(lang == 'fr'){
        var route = window.location.href
        if (!route.includes('fr')) {
          var origin = window.location.origin;
          var pathname =  window.location.pathname;
          window.location.href = `${origin}/fr${pathname}`
        } else{
          return
        }
      }
    });
  });
});

// show language ul items desktop

document.querySelectorAll('.custom_lag_select1').forEach(function(element) {
  element.addEventListener('click', function() {
  var langListUl = document.querySelector('.cus_langlist_ul')
  langListUl.classList.toggle('disclosure-list--visible');
  });
});

// language selector for desktop

var languageSelects = document.querySelectorAll(".custom-langlist .disclosure-list__item");
console.log(languageSelects);

// var mediaQuery = window.matchMedia("(min-width: 768px)");

languageSelects.forEach(function(langsel) {
  langsel.querySelectorAll(".custom_lang_link").forEach(function(anchor) {
    anchor.addEventListener("click", function(e) {
      e.preventDefault()
      console.log(anchor)
      var lang = anchor.getAttribute("lang")
      if(lang == 'en'){
        var route = window.location.href
        // if url contains french in it 
          if (route.includes('fr')) {
          var newRoute = route.replace('/fr', '');
          window.location.href = newRoute;
        }else{
            return 
        }
      }
      else if(lang == 'fr'){
        var route = window.location.href
        // if url contains english in it 
        if (!route.includes('fr')) {
          var origin = window.location.origin;
          var pathname =  window.location.pathname;
          window.location.href = `${origin}/fr${pathname}`
        } else{
          return
        }
      }
    });
  });
});

});

// desktop currency selector
document.querySelectorAll('#CurrencyList .disclosure-list__item').forEach(function(element) {
  element.addEventListener('click', function(e) {
    e.preventDefault();
    var val_cur = this.querySelector('a').dataset.value;
    console.log(val_cur, "currency value");
    var form = this.closest('form');
    if (form) {
      form.querySelector('[data-disclosure-input]').value = val_cur;
      form.submit();
    }
  });
});

// mobile currency selector

// document.querySelectorAll('#currency-target .disclosure-list__item').forEach(function(element) {
//     element.addEventListener('click', function() {
//       var val_cur = this.querySelector('a').dataset.value;
//       console.log(val_cur, "currency_val");
//       document.querySelector('.cust-currency [name=currency_code]').value = val_cur;
//       document.querySelector('.cust-currency form').submit();
//     });
//   });


document.querySelectorAll('#currency-target .disclosure-list__item').forEach(function(element) {
  element.addEventListener('click', function(e) {
    e.preventDefault();
    var val_cur = this.querySelector('a').dataset.value;
    console.log(val_cur, "currency value");
    var form = this.closest('form');
    if (form) {
      document.querySelector('.cust-currency [name=currency_code]').value = val_cur;
      form.submit();
    }
  });
});


